module.exports = __webpack_public_path__ + "assets/img/index_plat_six.b466bb2d.png";